/**
 * Market-Related Configuration
 *
 * This file contains market-related configuration such as Fear & Greed Index zones,
 * market sentiment thresholds, and other trading-related constants.
 */

/**
 * Fear & Greed Index Zone Thresholds
 *
 * The Fear & Greed Index is measured on a scale of 0-100:
 * - 0: Maximum Fear
 * - 100: Maximum Greed
 *
 * These thresholds define the boundaries between different market sentiment zones.
 */
export const FEAR_GREED_ZONES = {
  /**
   * Extreme Fear zone: 0 to 24
   * Market sentiment indicates extreme pessimism
   */
  EXTREME_FEAR_MAX: 25,

  /**
   * Fear zone: 25 to 44
   * Market sentiment indicates pessimism
   */
  FEAR_MAX: 45,

  /**
   * Neutral zone: 45 to 54
   * Market sentiment is balanced
   */
  NEUTRAL_MAX: 55,

  /**
   * Greed zone: 55 to 74
   * Market sentiment indicates optimism
   */
  GREED_MAX: 75,

  /**
   * Extreme Greed zone: 75 to 100
   * Market sentiment indicates extreme optimism
   * (No MAX needed - anything >= GREED_MAX is Extreme Greed)
   */
} as const;
